import EmployeeList from '@/components/Employee/EmployeeList'
import EmployeeForm from '@/components/Employee/EmployeeForm'
import EmployeeDetail from '@/components/Employee/EmployeeDetail'

let EmployeeRouter = [{
  path: '/employee',
  name: 'EmployeeList',
  component: EmployeeList,
  meta: {
    title: 'Employés',
    requiresAuth: true,
    authorizations: ['employee_index', 'desktop_access']
  }
}, {
  path: '/employee/new',
  name: 'EmployeeNew',
  component: EmployeeForm,
  meta: {
    title: 'Nouvel employé',
    requiresAuth: true,
    authorizations: ['employee_new', 'desktop_access']
  }
}, {
  path: '/employee/:id/edit',
  name: 'EmployeeEdit',
  component: EmployeeForm,
  meta: {
    title: 'Modifier un employé',
    requiresAuth: true,
    authorizations: ['employee_edit', 'desktop_access']
  }
}, {
  path: '/employee/:id',
  name: 'EmployeeDetail',
  component: EmployeeDetail,
  meta: {
    title: 'Fiche employé',
    requiresAuth: true,
    authorizations: ['employee_show', 'desktop_access']
  }
}]

export default EmployeeRouter



// WEBPACK FOOTER //
// ./src/components/Employee/router.js